const LOCAL_STORAGE_TENANT_ID_KEY = "tenantId";

export function setLocalStorageTenantId(tenantId: string | null) {
  if (tenantId === null) {
    localStorage.removeItem(LOCAL_STORAGE_TENANT_ID_KEY);
    return;
  }

  if (typeof tenantId !== "string") {
    throw new Error("Tenant id must be a string");
  }
  localStorage.setItem(LOCAL_STORAGE_TENANT_ID_KEY, tenantId);
}

export function getLocalStorageTenantId(): string | null {
  return localStorage.getItem(LOCAL_STORAGE_TENANT_ID_KEY);
}
